<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>منهج المشروع</h2>
        </div>
    </div>
</div>


<div class="service-details ptb-100">
    <div class="container">
      
        <div class="service-details-content">

            <div class="row">
                
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        مقدمة في صفات الحروف العربية من حلقة رقم 11 ( الاتقان لتلاوة القران)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/QzJ_hPejHHo?si=kEyqzEJ72QUTnIFl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الصفة 2 من الصفات المتضادة : (الشدة #الرخاوة #البينية ) برنامج الاتقان لتلاوة القران ح12

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/I1EvSudkJWI?si=W0mR2-y79L-TlkYc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الصفة 2 من الصفات المتضادة : (1- الشدة ) برنامج الاتقان لتلاوة القران حلقة 12

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/HU4eWHm5OAs?si=OyTT0ORtBvs1OLeT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الصفة 2 من الصفات المتضادة :( 2 #الرخاوة 3 #البينية ) الاتقان لتلاوة القران حلقة 12

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/IF8nm-Jw0Os?si=RYLRkZoKdEnDoZCp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        تلخيص لصفتي الهمس والشدة وضدهما الجهر والرخاوة من حلقة 13 الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/58mxvEj1f6g?si=uc3NSgGM7aO0QgBj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الصفة 3 من الصفات المتضادة : (الاستعلاء#الاستفال ) برنامج الاتقان لتلاوة القران حلقة 14


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/7dBw-SL3OkM?si=_lh_txR3pG6JmIlo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الصفة 4 من الصفات المتضادة : (الاطباق # الانفتاح )برنامج الاتقان لتلاوة القران حلقة 14


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/TPr3FKbSJYA?si=EjUkoX6Hsna69j7g" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>

                        الصفة 5 من الصفات المتضادة : (الإذلاق # الإصمات) برنامج الاتقان لتلاوة القران ح 14

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/yVoCsdKO6_4?si=TUxuy1lWqJGEawku" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>

                        1- صفة الصفير.. برنامج الاتقان لتلاوة القران من (ح 15)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/fAiaDWaxapg?si=3mfj1CNPdESR21VY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        2- صفة القلقة ( برنامج الاتقان لتلاوة القران ) من ح15


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/E0rXs8R8cak?si=VtqYPKJZKkda2bT0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        4 - صفة الانحراف: صفة لحرفي ( ل) ،( ر ) - برنامج الاتقان لتلاوة القران ح 17


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/TtYuEUtdbGo?si=uq8BZ7kto7BfY4Cl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        5- صفة التكرير : في حرف (الراء) فقط من برنامج الاتقان لتلاوة القران من ح17


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/RTFW856EOMc?si=ZhIUcB9a9-Hd1JgP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        6- صفة التفشي : (حرف الشين ) من ح 18 برنامج الاتقان لتلاوة القران
                    </h5>

                    <iframe width="560" height="315" src="https://www.youtube.com/embed/YZ8eSHToPcQ?si=7PO6MHzpo9ywmc7f" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        6- صفة التفشي : (حرف الشين ) من ح 18 برنامج الاتقان لتلاوة القران


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/YZ8eSHToPcQ?si=FOk5833D19wT2NYd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/X-JEl4RL3Qs?si=vCS2qudklxGrZIFp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </h5>
                    8 - صفة الغنة : (:ن، م )برنامج الاتقان لتلاوة القران ح 18

                </div>


                

            </div>

            </div>
    </div>
</div>


